<!-- <div class="row">
    <div class="col-md-12"> -->
        <div class="eip-mxy-20">
            <fm-pivot #flexMonsterGrid [licenseKey]="flexmonsterLicense"   *ngIf="newreport"
                [report]='newreport' id="idFMGridCommonDialog" [toolbar]="true">
            </fm-pivot>
        </div>
    <!-- </div>
</div> -->